<template>
  <div>
    <!----询比单信息------>
    <div v-if="showOrder" class="card no-margin m-b-20 m-t-20">
      <div class="section">
        <div class="section-title">
          <base-section-title title="询比单信息" />
        </div>
        <div class="section-content">
          <jczh-descriptions
            :info="orderInfo"
            :option="orderOptions"
            :el-attrs="{
              size: 'medium',
              column: 1,
              labelStyle: {
                width: '140px',
                whiteSpace: 'nowrap',
                textAlign: 'right'
              }
            }"
          />
        </div>
      </div>
    </div>

    <order-candidate-template
      :detail-vo-list="detailVoList"
      :candidate-info="candidateForm"
      :candidate-id="candidateId"
      :require-tax="requireTax"
      :is-dollar="isDollar"
      :item-schema-list="itemSchemaList"
      :internal-attachment-ids="internalAttachmentIds"
      :is-table-grey-features="isTableGreyFeatures"
      :order-id="orderId"
    />

    <!-- 审批备注 -->
    <record-remark
      v-if="requestQuery.pageFrom == 'auditDetail'"
      class="m-t-16"
      :remark-list="remarkList"
    />

    <!-- 审批历史 -->
    <record-history
      v-if="requestQuery.pageFrom == 'auditDetail'"
      :record-list="flowListing"
    />
  </div>
</template>

<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import OrderCandidateTemplate from '@/components/inquiry/OrderCandidateTemplate.vue'
import RecordHistory from '@/components/common/RecordHistory'
import RecordRemark from '@/components/common/RecordRemark'

import { inquiryRequireTaxDict } from '@/dictionary/project/inquiry'
import { projectTypeDict, currencyTypeDict } from '@/dictionary/project/common'

import {
  getNewestCandidateInfoApi,
  getInquiryOrderApi
} from '@/api/procure/inquiry'
import { cloneDeep } from 'lodash'
export default {
  name: 'InquiryCandidateInfo',

  components: {
    OrderCandidateTemplate,
    BaseSectionTitle,
    RecordHistory,
    RecordRemark
  },

  props: {
    requestQuery: {
      type: Object,
      required: true
    },

    showOrder: {
      type: Boolean,
      default: true
    },
    isByOrderId: {
      type: Boolean,
      default: true
    },

    // 备注列表
    remarkList: {
      type: Array,
      default: () => {
        return []
      }
    },

    isWuling: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      orderInfo: {},
      flowListing: [],
      orderOptions: [
        {
          label: '询比单名称',
          prop: 'orderName'
        },
        {
          label: '询比单编号',
          prop: 'orderCode'
        },
        {
          label: '项目类型',
          prop: 'projectType',
          filter: value => projectTypeDict.translate(value).label || ' - '
        },
        {
          label: '收货地址',
          prop: 'address',
          filter: value => {
            if (value?.receivingCountry === '中国') {
              return value?.receivingProvince
                ? `${value?.receivingProvince} ${value?.receivingCity} ${value?.receivingArea}`
                : ' - '
            } else {
              return value?.receivingCountry
            }
          }
        },
        {
          label: '详细地址',
          prop: 'address.address'
        }
      ],

      requireTax: '',
      detailVoList: [],
      candidateId: '',
      candidateForm: {
        publicity: 0, // 是否发布公示，1是，0不是
        noticeTitle: '', // 公示标题
        noticeContent: '', // 公示内容
        itemList: [], // 授标列表
        awardType: '', // 授标方式
        noticePublishTime: '',
        noticeReleaseStatus: '',
        candidateAttachmentIds: [],
        // 取消授标品目
        cancelList: [],
        cancelAttachmentIds: [],
        cancelReason: ''
      },
      itemSchemaList: [],
      isDollar: false,
      isTableGreyFeatures: false
    }
  },

  computed: {
    orderId() {
      return this.requestQuery.orderId
    },

    internalAttachmentIds() {
      return this.orderInfo?.internalAttachmentIds || []
    }
  },

  watch: {
    'requestQuery.orderInfo': {
      handler: function(val) {
        if (val) {
          this.orderInfo = this.requestQuery?.orderInfo?.order || {}
          this.requireTax =
            this.orderInfo.offerRequireTax === inquiryRequireTaxDict.YES.value
          this.isDollar =
            this.orderInfo.currencyType === currencyTypeDict.DOLLAR.value
          this.getCandidateInfo()
        }
      },
      immediate: true
    },

    'requestQuery.orderId': {
      handler: function(val) {
        if (this.isByOrderId && val) {
          this.getOrderInfo()
          this.getCandidateInfo()
        }
      },
      immediate: true
    },

    'requestQuery.itemSchemaList': {
      handler(val) {
        if (val?.length > 0) {
          this.itemSchemaList = cloneDeep(val)
        }
      },
      immediate: true
    },

    isWuling(val) {
      this.isTableGreyFeatures = val
    }
  },

  methods: {
    /**
     * 获取询比单信息
     */
    getOrderInfo() {
      return getInquiryOrderApi({ orderId: this.orderId })
        .then(res => {
          console.log('获取询比单信息', res?.data)
          this.orderInfo = res?.data?.order || {}
          this.flowListing = res?.data?.flowListing || []
          this.whetherWuling(Boolean(res.data?.order?.isWuling))

          this.requireTax =
            this.orderInfo.offerRequireTax === inquiryRequireTaxDict.YES.value
          this.isDollar =
            this.orderInfo.currencyType === currencyTypeDict.DOLLAR.value
          this.itemSchemaList = res?.data?.itemSchemaList || []
        })
        .catch(err => {
          console.error('获取询比单信息失败', err)
          this.$message.error(err.message || '获取询比单信息')
        })
    },

    // 获取候选信息
    getCandidateInfo() {
      getNewestCandidateInfoApi({ orderId: this.orderId })
        .then(res => {
          const data = res.data || {}
          console.log('获取候选信息', data)
          Object.keys(this.candidateForm).forEach(key => {
            if (key in data) {
              this.candidateForm[key] = data[key]
            }
          })
          this.detailVoList = data.detailDtoList || []
          this.candidateId = data.calibrationId
          this.$emit('setCandidateInfo', data)
        })
        .catch(err => {
          if (err) {
            this.$message.error(err.message || '获取候选信息失败')
          } else {
            console.log('candidate info error >>> ', err)
          }
        })
    },

    whetherWuling(bool) {
      this.isTableGreyFeatures = bool
      this.$emit('isWuling', bool)
    }
  }
}
</script>

<style scoped></style>
